import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./biltyReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable.js";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { useLocation, useHistory } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import getLoggedinFyear from "../utils/getLoggedinFyear";
let ex_data = [];

function CrossingInWardReportForBBAC({ sessionObject }) {
  const history = useHistory();
  const branchId = sessionObject.sessionVariables.branch_id;
  const [payType, setPayType] = useState("all");
  const [totalRows, setTotalRows] = useState(0);

  const fyearObj = getLoggedinFyear(sessionObject);

  const columns = React.useMemo(
    () => [
      {
        Header: "Challan Inward No",
        accessor: "crossing_inward_no",
        canFilter: true,
      },
      {
        Header: "Created Date",
        accessor: (row) =>
          row.crossing_inward_date
            ? row.crossing_inward_date.split("T")[0]
            : "",
        canFilter: true,
        width: "120px",
        minWidth: "120px",
      },
      {
        Header: "Transport",
        accessor: "transporter_name",
        canFilter: true,
      },
      // {
      //   Header: "No Of Bilties",
      //   accessor: "no_of_bilties",
      //   canFilter: true,
      // },
      {
        Header: "Packages",
        accessor: "total_pkgs",
        canFilter: true,
      },
      // {
      //   Header: "To Pay",
      //   accessor: "to_pay",
      //   canFilter: true,
      // },
      // {
      //   Header: "Door Del.",
      //   accessor: "door_del_charge",
      //   canFilter: true,
      // },
      {
        Header: "Crossing Hire",
        accessor: "freight",
        canFilter: true,
      },
      {
        Header: "Paid",
        accessor: "paid",
        canFilter: true,
      },
      {
        Header: "Total Amount",
        accessor: "to_pay",
        canFilter: true,
      },
      {
        Header: "Balance",
        accessor: "balance",
        canFilter: true,
      },
    ],
    [],
  );

  // We'll start our table without any data
  const [data, setData] = React.useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const fetchIdRef = React.useRef(0);
  const download_ref = React.useRef(null);
  const sortIdRef = React.useRef(0);
  const [dateState, setDateState] = React.useState({
    date_from: new Date(fyearObj.start_fyear),
    date_to: new Date(fyearObj.end_fyear),
    in_stock: "Y",
    // greater_amt: "N"
  });
  const [finalInput, setFinalInput] = React.useState({});
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  let query = useQuery();

  useEffect(() => {
    const reportType = query.get("report_type");
    console.log("data is : ", { data });
    // myForm.setPageStateByField("voucher_type", voucher);
    setDateState({
      ...dateState,
      ["report_type"]: reportType,
    });
  }, []);

  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
      // This will get called when the table needs new data
      // You could fetch your data from literally anywhere,
      // even a server. But for this example, we'll just fake it.

      // Give this fetch an ID
      const fetchId = ++fetchIdRef.current;
      // console.log("12323", sortBy, customFilters, fetchId);
      for (let key in customFilters) {
        console.log("Key", customFilters[key].toLowerCase(), key);
        if (customFilters[key].toLowerCase() == "none") {
          customFilters[key] = null;
        }
      }
      // Set the loading state
      setLoading(true);

      try {
        if (fetchId === fetchIdRef.current) {
          // console.log("Date state", dateObject);
          let newObject = {};
          // if (dateObject.report_type == "bilty"){
          //   newObject.created_from = String(
          //     sessionObject.sessionVariables.branch_id
          //   );
          //   // if (dateObject.in_stock == "N") {
          //   //   newObject.created_from = String(
          //   //     sessionObject.sessionVariables.branch_id
          //   //   );
          //   // } else {
          //   //   newObject.owned_by = String(
          //   //     sessionObject.sessionVariables.branch_id
          //   //   );
          //   // }

          // }
          newObject.created_from = String(branchId);
          // if (dateObject.greater_amt == "Y") {
          //     newObject.greater_amt = String(
          //         1
          //     );
          // }
          // if (dateObject.report_type == "inward"){
          //   newObject.owned_by = String(
          //     sessionObject.sessionVariables.branch_id
          //   );
          //   // if (dateObject.in_stock == "N") {
          //   //   newObject.created_from = String(
          //   //     sessionObject.sessionVariables.branch_id
          //   //   );
          //   // } else {
          //   //   newObject.owned_by = String(
          //   //     sessionObject.sessionVariables.branch_id
          //   //   );
          //   // }
          // }

          newObject = { ...newObject, ...customFilters };

          if (["bgtc", "ase"].includes(process.env.REACT_APP_CLIENT) && payType !== "all") {
            newObject.pay_type = Number(payType);
          }

          let inputData = {
            paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
            sort_fields: sortBy,
            filter_fields: newObject,
            date_dict: {
              date_from: dateObject.date_from,
              date_to: dateObject.date_to,
            },
          };

          setFinalInput(inputData);
          // console.log("Data to send: ", inputData);

          let response = await fetch(
            SERVER_URL + "/report/crossing_inward_report",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(inputData),
            },
          );

          if (!response.ok) {
            throw new Error(
              "API request failed with status " + response.status,
            );
          }

          let resp = await response.json();
          console.log("data received: ", resp);

          if (resp && resp.data && "total_rows" in resp) {
            let dataArray = Object.values(resp.data || {});

            setData(dataArray);

            setTotalRows(resp.total_rows || 0);

            const totalAmt = dataArray.reduce(
              (sum, row) => sum + Number(row.to_pay_amount || 0),
              0,
            );

            setTotalAmount(totalAmt);

            setPageCount(Math.ceil((resp.total_rows || 0) / pageSize));
          }
        }
      } catch (err) {
        console.error("MR Report API failed:", err);
        setData([]);
        setTotalAmount(0);
        setPageCount(0);
      } finally {
        setLoading(false);
      }

      // We'll even set a delay to simulate a server here
      //   setTimeout(() => {
      //     // Only update the data if this is the latest fetch
      //     if (fetchId === fetchIdRef.current) {
      //       const startRow = pageSize * pageIndex;
      //       const endRow = startRow + pageSize;
      //     //   setData(serverData.slice(startRow, endRow));
      //       console.log("data", data);
      //       // Your server could send back total page count.
      //       // For now we'll just fake it, too
      //       setPageCount(Math.ceil(serverData.length / pageSize));

      //       setLoading(false);
      //     }
      //   }, 1000);
    },
    [payType],
  );

  const handleViewClick = (cell) => {
    console.log("cell:", cell);

    const crossingNo = cell?.[0]?.value;

    if (!crossingNo) return;

    history.push("/crossingInward", {
      crossingNo: crossingNo,
    });
  };

  return (
    <div className="page-marfatiya-wise">
      <div className="report-bilty">
        <div className="form-header">Crossing Inward Report</div>
        <div className="report-bilty-table-container">
          <div className="report-field-row ">
            <div>
              From Date:{" "}
              <DatePicker
                dateFormat="dd-MM-yyy"
                selected={dateState.date_from}
                onChange={(date) =>
                  setDateState({
                    ...dateState,
                    ["date_from"]: date,
                  })
                }
                // ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
                // disabled={checkDisabledCondition({ name: "input_date" })}
                // onKeyPress={(a) => {
                //   if (a.key == "Enter") {
                //     myForm.makeFocusOnParticularFieldForItem(
                //       "eway_bill_no",
                //       0,
                //       "eway_bill_no"
                //     );
                //   }
                // }}
              />
            </div>
            <div>
              To Date:{" "}
              <DatePicker
                dateFormat="dd-MM-yyy"
                selected={dateState.date_to}
                onChange={(date) =>
                  setDateState({
                    ...dateState,
                    ["date_to"]: date,
                  })
                }
                // ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
                // disabled={checkDisabledCondition({ name: "input_date" })}
                // onKeyPress={(a) => {
                //   if (a.key == "Enter") {
                //     myForm.makeFocusOnParticularFieldForItem(
                //       "eway_bill_no",
                //       0,
                //       "eway_bill_no"
                //     );
                //   }
                // }}
              />
            </div>
            {["bgtc", "ase"].includes(process.env.REACT_APP_CLIENT) && (
              <div>
                <label className="form-label-w">Pay Type:</label>
                <select
                  value={payType}
                  onChange={(e) => setPayType(e.target.value)}
                >
                  <option value="all">All</option>
                  <option value="2">Paid</option>
                  <option value="1">To Pay</option>
                  <option value="4">To Be Billed</option>
                </select>
              </div>
            )}
          </div>
          <div className="chform-row">
            <div className="form-row-m">
              <label className="form-label-w">Total</label>
              <input disabled={true} value={totalRows} />
            </div>
          </div>

          <ReportTable
            columns={columns}
            data={data}
            fetchData={fetchData}
            dateObject={dateState}
            loading={loading}
            pageCount={pageCount}
            canView={true}
            handleViewClick={handleViewClick}
          />
          <div className="form-footer">
            <button style={{ display: "none" }}>
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-table-xls-button"
                table="crossing_inward_report_excel"
                filename="Crossing_Inward_Report"
                sheet="tablexls"
                buttonText="Download as XLS"
                ref={(a) => (download_ref.current = a)}
              />
            </button>
            <button
              className="download-table-xls-button"
              onClick={async () => {
                setLoading(true);
                let dataToSend = {
                  date_dict: finalInput.date_dict,
                  filter_fields: finalInput.filter_fields,
                };

                console.log("data to send in EXCEL:", dataToSend);

                let resp = await fetch(
                  SERVER_URL + "/report/crossing_inward_report",
                  {
                    method: "POST",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToSend),
                  },
                );

                let response = await resp.json();

                if (response["data"] && "total_rows" in response) {
                  ex_data = Object.values(response.data || {});
                }
                setLoading(false);
                download_ref.current.handleDownload();
              }}
            >
              Download as XLS
            </button>
            {ReportExcel.excel_crossing_inward_data(
              columns,
              ex_data,
              fetchData,
              dateState,
              loading,
              pageCount,
              dateState,
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CrossingInWardReportForBBAC;
